import { useQuery } from 'src/core/api/hooks/useQuery';
import { useQueryStates } from 'src/core/api/hooks/useQueryStates';
import { type QueryState } from 'src/core/api/queryState';
import { withoutOptionalFields } from 'src/core/common/components/FilterBuilder';
import { useActivePayableFilter } from 'src/core/modules/payable/components';

import { type PayablesBucketsQueryRawResult } from '../../../bookkeep/apis/prepare-payable';
import {
  GET_PAYABLES_BUCKETS_STATS,
  makeGetPayablesBucketsStatsVariables,
} from '../../../bookkeep/apis/prepare-payable/usePayablesBucketsStatsQuery/query';
import { toAPIPayableFiltersV2 } from '../../../bookkeep/prepare-payables/models';
// import { useExportPayablesCount } from '../../payable-export/apis';

type PayableStats = {
  toPrepare: number;
  toExport: number;
};

export const useOrganisationEntityPayablesQuery = (
  companyId: string,
  options: {
    isEnabled: boolean;
  } = {
    isEnabled: true,
  },
): QueryState<PayableStats> => {
  const filtersV2 = useActivePayableFilter()?.filter;

  const prepageFilters = {
    companyId,
    filtersV2: toAPIPayableFiltersV2({
      filters: filtersV2 ? withoutOptionalFields(filtersV2) : undefined,
      withBookkeepingStartDate: true,
    }),
  };

  return useQueryStates({
    states: {
      payablesToPrepare: useQuery<PayablesBucketsQueryRawResult, PayableStats>({
        key: ['organisation-reporting', companyId, 'payables-to-prepare'],
        request: {
          type: 'graphQL',
          target: 'v2',
          query: GET_PAYABLES_BUCKETS_STATS,
          variables: makeGetPayablesBucketsStatsVariables(prepageFilters),
        },
        isEnabled: options.isEnabled,
      }),
      // payablesToExport: useExportPayablesCount([undefined, undefined]),
    },
    reshapeData: ({ payablesToPrepare /** payablesToExport */ }) => ({
      toPrepare: payablesToPrepare.company.payablesFiltered?.totalCount ?? 0,
      // toExport: payablesToExport.payablesCounts.unexportedPayablesCount,
      toExport: 0,
    }),
  });
};
